import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-component-error-warning',
    templateUrl: './error-warning.component.html',
    styleUrls: ['./error-warning.component.css']
})

export class ErrorWarningComponent implements OnInit {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(private router : Router) { }
    ngOnInit() {}

    goToHomePage() {
        this.router.navigate(["/"]);
    }
}